<template>
  <FormRow class="designation" inline>
    <FormSelect field="applications.0.campaign">
      <option selected="selected" value="General Donation">General NCSY Programs</option>
      <option value="JSU">Jewish Clubs in Public Schools</option>
      <option value="Summer Scholarship">Summer Program Scholarships</option>
      <option value="Mitzvah Fund">Mitzvah Fund</option>
      <option value="Shabbaton Scholarship">Shabbaton Scholarships</option>
      <option value="Latte & Learning">Latte &amp; Learning</option>
      <option value="Teaneck">Teaneck NCSY</option>
      <option value="Highland Park">Highland Park NCSY</option>
      <option value="West Orange">West Orange NCSY</option>
      <option value="Fair Lawn">Fair Lawn NCSY</option>
      <option value="Metrowest JSU">Metro West NCSY JSU</option>
      <option value="Twin Rivers">Twin Rivers NCSY</option>
      <option value="Winter Regional">Winter Regional 2023</option>
    </FormSelect>
    <ErrorLabel field="applications.0.campaign" style="text-align: right" />
  </FormRow>
</template>
<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue } = usePaymentForm();

    return {
      getValue,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>
